import Vue from "vue";
import VueI18n from "vue-i18n";
import en from '@/translations/en'
import tc from '@/translations/tc'
import sc from '@/translations/sc'

const messages = {
  en,
  tc,
  sc
}

Vue.use(VueI18n);

function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
}

let startLocale = "en"
let localeCookieValue = getCookie('app-locale');
let urlLocales = ['en', 'sc', 'tc'];

// By default it prepends a '/', so we're checking the two chars after that as it's (en, sc, or tc)
let baseLocale = window.location.pathname.split('/');
baseLocale = baseLocale[1];

if (urlLocales.includes(baseLocale)) {
  startLocale = baseLocale;
} else if (localeCookieValue != undefined) {
  // Retrieve locale from cookie (if it's already been set)
  startLocale = localeCookieValue;
} else {
  switch (navigator.language.toLowerCase()) {
    case 'zh-hk':
    case 'zh-sg':
    case 'zh-tw':
      startLocale = 'tc'
    case 'zh-cn':
      startLocale = 'sc'
    default:
      startLocale = 'en'
  }
}


// We could optimise this further in the future by lazy loading translation files: https://kazupon.github.io/vue-i18n/guide/lazy-loading.html
const i18n = new VueI18n({
  locale: startLocale, // set locale
  fallbackLocale: 'en',
  messages // set locale messages
});

export default i18n;